<div class="row filter-collapse" #filterCollapse>
    <div class="col-12"> 
        <div class="row">
            <div class="form-group col-12 col-md-6">
                <label for="situacaoFilter" class="col-form-label">Situação</label>
                <select class="form-control" name="situacaoFilter" id="situacaoFilter" 
                        [ngModel]="filter.situacao || ''" (ngModelChange)="filter.situacao = $event ? $event : null; isFilterDirty = true;"
                        #situacaoFilter="ngModel">
                    <option value="">Todas as situações</option>
                    <option *ngFor="let situacao of situacoes" [ngValue]="situacao.id">{{situacao.nome}}</option>
                </select>                                        
            </div> 
            <div class="form-group col-12 col-md-6">
                <label for="perfilFilter" class="col-form-label">Perfil</label>
                <select class="form-control" name="perfilFilter" id="perfilFilter" 
                        [ngModel]="filter.perfil || ''" (ngModelChange)="filter.perfil = $event ? $event : null; isFilterDirty = true;"
                        #perfilFilter="ngModel">
                    <option value="">Todos os perfis</option>
                    <option *ngFor="let perfil of perfis" [ngValue]="perfil.id">{{perfil.nome}}</option>
                </select>                                        
            </div>                        
        </div>
        <div class="row">                       
            <div class="form-group col-12">
                <label for="filterRepresentante" class="col-form-label">Representante</label>
                <sgt-typeahead-representante [(ngModel)]="filter.representante" name="filterRepresentante" id="filterRepresentante"
                    #representante="ngModel" [ngControl]="representante"
                    (typeaheadChange)="onChangeRepresentante($event)">
                </sgt-typeahead-representante>                                                                  
            </div>             
        </div> 
        <!-- Marcas -->
        <div class="row" *ngIf="isTipoMercadoMarca()">
            <div  class="form-group col-12 checkbox-marcas">
                <label class="col-form-label">Marcas</label>
                <div class="custom-control custom-checkbox custom-control-inline" *ngFor="let itemMarca of filter.itensMarcas">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="itemMarca.selected" name="'itemMarca'_{{itemMarca.nome}}" id="'itemMarca'_{{itemMarca.nome}}">
                    <label class="custom-control-label" for="'itemMarca'_{{itemMarca.nome}}">{{itemMarca.nome}}</label>
                </div>
            </div>
        </div>         
    </div>
</div>